import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Stack/Stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["NavBar"] */ "/vercel/path0/src/app/[lang]/components/NavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSelector"] */ "/vercel/path0/src/components/LanguageSelector.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/RediFooter.module.css");
